var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWe53MainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 43,
    fill: "none",
    viewBox: "0 0 113 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.788 8.515H73.974v16.473h4.119c4.603 0 5.411.095 6.304.738 1.269.914 1.264 3.03-.009 3.866-2.855 1.878-10.078.155-10.078.155l-1.18 6.231c6.226.826 17.295 2.198 19.45-5.564.301-1.086.372-3.79.128-4.937-.843-3.982-4.245-6.102-9.788-6.102h-1.826v-4.303h10.421l1.273-6.557ZM93.471 15.072h9.169l-6.164 6.307-.666 3.584 3.49.055c3.767.059 4.288.132 5.197.733 1.365.901 1.247 3.173-.209 4.02-2.838 1.655-9.452-.024-9.452-.024l-1.184 6.231c6.964 1.293 19.283 1.77 19.348-8.061.014-2.217-.364-3.488-1.444-4.855-1.505-1.905-2.74-2.203-4.779-2.697a92.843 92.843 0 0 1-.619-.151s4.598-4.541 5.326-5.174V8.515h-16.74l-1.273 6.557Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.279.325 48.383 23.874c-.488.578-.07 1.453.695 1.453h12.638l-5.342 16.512c-.298.923.91 1.58 1.548.843l13.956-16.115a.723.723 0 0 0 .175-.472V17.98a.72.72 0 0 0-.72-.721h-5.955l4.466-16.134c.255-.92-.946-1.533-1.565-.799Z",
    fill: "#40E569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m58.276 29.726-2.015 6.226H31.556l1.208-6.226h25.511ZM49.792 19.23l-2.875 3.403c-.706.836-.817 1.84-.519 2.699H33.617L34.8 19.23h14.99ZM58.864 8.492l-5.257 6.224h-17.93l1.208-6.224h21.98ZM26.968 8.492h7.96L29.6 35.952h-7.974l-4.18-10.787-4.13 10.787H5.279C3.632 27.274 0 8.492 0 8.492h7.663l2.71 16.673 3.636-11.67h6.813l3.204 10.122 2.942-15.125Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWe53MainLogo);
export default __webpack_public_path__ + "static/media/we53-main-logo.6d1047d5eba34dd0394143540db7ce80.svg";
export { ForwardRef as ReactComponent };